import LegalHeader from "@/components/LegalHeader";
import Footer from "@/components/Footer";

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-background">
      <LegalHeader />
      <main className="pt-20 pb-16">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-primary mb-4">
                Disclaimer
              </h1>
              <p className="text-muted-foreground">
                Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
              </p>
            </div>

            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">1. Informazioni Generali</h2>
                <p>
                  <strong>Ristorante Da Armando</strong><br />
                  Via Aganoor Pompili, 25<br />
                  06065 Passignano sul Trasimeno (PG)<br />
                  P.IVA: 03963890540<br />
                  Email: info@ristorantearmando.it<br />
                  Tel: +39 075 388 0397
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">2. Accuratezza delle Informazioni</h2>
                <p>
                  Il Ristorante Da Armando si impegna a fornire informazioni accurate e aggiornate sul proprio sito web. 
                  Tuttavia, non garantiamo l'assoluta accuratezza, completezza o tempestività delle informazioni contenute nel sito.
                </p>
                <p className="mt-4">
                  Le informazioni potrebbero contenere errori o omissioni e potrebbero essere modificate senza preavviso. 
                  Si consiglia di verificare sempre le informazioni direttamente con il ristorante.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">3. Disponibilità dei Servizi</h2>
                <p>
                  Il Ristorante Da Armando si riserva il diritto di:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Modificare o sospendere i servizi offerti</li>
                  <li>Cambiare orari di apertura senza preavviso</li>
                  <li>Modificare il menu in base alla disponibilità degli ingredienti</li>
                  <li>Rifiutare servizio per motivi di sicurezza o organizzativi</li>
                  <li>Chiudere temporaneamente il ristorante per manutenzione o eventi speciali</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">4. Allergie e Intolleranze</h2>
                <p>
                  Il Ristorante Da Armando si impegna a fornire informazioni accurate sugli ingredienti utilizzati nei propri piatti. 
                  Tuttavia, non possiamo garantire l'assenza completa di allergeni dovuta a:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Possibili contaminazioni durante la preparazione</li>
                  <li>Modifiche nei fornitori di ingredienti</li>
                  <li>Errori umani nella preparazione</li>
                </ul>
                <p className="mt-4">
                  Si consiglia ai clienti con allergie o intolleranze di informare sempre il personale e di non fare affidamento 
                  esclusivamente sulle informazioni del sito web.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">5. Prenotazioni Online</h2>
                <p>
                  Il sistema di prenotazione online è fornito come servizio di convenienza. 
                  Il Ristorante Da Armando non garantisce:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>La disponibilità immediata di tutti gli orari richiesti</li>
                  <li>L'assenza di errori tecnici nel sistema</li>
                  <li>La ricezione immediata delle conferme di prenotazione</li>
                  <li>La compatibilità con tutti i dispositivi o browser</li>
                </ul>
                <p className="mt-4">
                  Si consiglia di contattare direttamente il ristorante per confermare le prenotazioni importanti.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">6. Contenuti del Sito</h2>
                <p>
                  I contenuti del sito web, incluse immagini, descrizioni e prezzi, sono forniti a scopo informativo. 
                  Il Ristorante Da Armando non si assume responsabilità per:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Differenze tra le immagini e i piatti effettivamente serviti</li>
                  <li>Modifiche ai prezzi non ancora aggiornati sul sito</li>
                  <li>Discrepanze nelle descrizioni dei piatti</li>
                  <li>Errori di battitura o informazioni obsolete</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">7. Link Esterni</h2>
                <p>
                  Il sito web può contenere link a siti web di terze parti. 
                  Il Ristorante Da Armando non si assume responsabilità per:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Il contenuto dei siti web collegati</li>
                  <li>La disponibilità dei siti web collegati</li>
                  <li>Le politiche di privacy dei siti web collegati</li>
                  <li>Eventuali danni derivanti dall'utilizzo di siti web collegati</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">8. Limitazione di Responsabilità</h2>
                <p>
                  In nessun caso il Ristorante Da Armando sarà responsabile per:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Danni diretti, indiretti, incidentali o consequenziali</li>
                  <li>Perdite di profitti, dati o opportunità commerciali</li>
                  <li>Danni derivanti dall'utilizzo o dall'impossibilità di utilizzare il sito</li>
                  <li>Interruzioni del servizio o errori tecnici</li>
                  <li>Danni causati da virus o malware</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">9. Legge Applicabile</h2>
                <p>
                  Questo disclaimer è regolato dalla legge italiana. 
                  Eventuali controversie saranno risolte dal Tribunale competente di Perugia.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">10. Modifiche al Disclaimer</h2>
                <p>
                  Il Ristorante Da Armando si riserva il diritto di modificare questo disclaimer in qualsiasi momento. 
                  Le modifiche saranno pubblicate su questa pagina e saranno efficaci dalla data di pubblicazione.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">11. Contatti</h2>
                <p>Per domande su questo disclaimer, può contattarci:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Email: info@ristorantearmando.it</li>
                  <li>Telefono: +39 075 388 0397</li>
                  <li>Posta: Via Aganoor Pompili, 25, 06065 Passignano sul Trasimeno (PG)</li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Disclaimer; 